export default "__VITE_ASSET__BBY4i8Ob__"